
import React from 'react';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SitemapItem } from '@/data/sitemapData';

interface SitemapCategoryTableProps {
  title: string;
  items: SitemapItem[];
}

const SitemapCategoryTable: React.FC<SitemapCategoryTableProps> = ({ title, items }) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">{title}</h2>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Calculator Name</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.path}>
                <TableCell>
                  {item.available ? (
                    <Link to={item.path} className="font-bold text-primary hover:underline">
                      {item.name}
                    </Link>
                  ) : (
                    item.name
                  )}
                </TableCell>
                <TableCell>
                  {item.available ? (
                    <span className="text-green-600 font-medium">Available</span>
                  ) : (
                    <span className="text-amber-600">Coming Soon</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default SitemapCategoryTable;
